import {
  QConfigPassingCriteriaType,
  QConfigTimeLimitType,
  type UpdateQConfigSettingsAsDraftInput,
} from '@exam-management/graphql';

import type { QConfigSettingsFormInput } from './qconfig-settings-form-schema';

function getTimeLimit(examTiming: NonNullable<QConfigSettingsFormInput['examTiming']>) {
  const { option, overall, structures } = examTiming;

  if (option === QConfigTimeLimitType.All && overall) {
    const value = overall.getHours() * 3600 + overall.getMinutes() * 60;
    return {
      type: QConfigTimeLimitType.All,
      values: [{ qConfigStructureIds: undefined, value: value, order: 0 }],
    };
  } else if (option === QConfigTimeLimitType.ByStructure && structures) {
    return {
      type: QConfigTimeLimitType.ByStructure,
      values: structures.map((structure, order) => {
        const timeLimit = structure.timeLimit;
        const value = (timeLimit?.getHours() ?? 0) * 3600 + (timeLimit?.getMinutes() ?? 0) * 60;
        return {
          qConfigStructureIds: structure.parts.flatMap((part) => part.value),
          value: value,
          order: order,
        };
      }),
    };
  } else {
    return undefined;
  }
}

export default function updateQConfigSettingsAsDraftMapper(
  formData: QConfigSettingsFormInput,
  qConfigId: string,
) {
  const { passingCriteria, examTiming, randomization } = formData;
  const structures = passingCriteria.structures ?? {};

  const overallPassingCriteria =
    typeof passingCriteria.overall === 'number'
      ? {
          type: QConfigPassingCriteriaType.Percent,
          value: passingCriteria.overall,
        }
      : undefined;

  const structurePassingCriteria = structures
    ? Object.keys(structures).map((key) => {
        const value = structures[key] ?? null;
        const passingCriteria =
          typeof value === 'number'
            ? {
                type: QConfigPassingCriteriaType.Percent,
                value: value,
              }
            : null;
        return {
          structureId: key,
          passingCriteria: passingCriteria,
        };
      })
    : undefined;

  const timeLimit = examTiming ? getTimeLimit(examTiming) : undefined;

  const result: UpdateQConfigSettingsAsDraftInput = {
    qConfigId: qConfigId,
    randomType: randomization ?? null,
    passingCriteria: overallPassingCriteria,
    structurePassingCriteria: structurePassingCriteria,
    timeLimit: timeLimit,
  };
  return result;
}
